import { sectionApiSlice } from './../features/section/sectionSlice'
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import userReducer, { userApiSlice } from '../features/user/userSlice'
import { subjectApiSlice } from '../features/subject/subjectSlice'
import { courseApiSlice } from '../features/course/courseSlice'
import { rtkQueryErrorLogger } from './rtkQueryErrorLogger'
import { topicApiSlice } from '../features/topic/topicSlice'
import { courseSubjectApiSlice } from '../features/course/courseSubjectSlice'
import { courseTopicApiSlice } from '../features/course/courseTopicSlice'
import { testApiSlice } from '../features/section/testSlice'
import { videoLessonApiSlice } from '../features/section/videoLessonSlice'
import { studentApiSlice } from '../features/student/studentSlice'
import { teacherApiSlice } from '../features/teacher/teacherSlice'
import groupReducer, { groupApiSlice } from '../features/group/groupSlice'
import { groupSubjectApiSlice } from '../features/group/groupSubjectSlice'
import { courseUserApiSlice } from '../features/course/courseUserSlice'
import { curatorStudentsApiSlice } from '../features/curator/curatorStudents'
import { coursePriceApi } from '../features/course/coursePrice'
import { courseSubjectPriceApi } from '../features/course/courseSubjectPrice'
import { coursePromotionApi } from '../features/course/coursePromotion'
import { coursePackageApi } from '../features/course/coursePackage'
import { courseExamApiSlice } from '../features/course/courseExamSlice'
import { managerApi } from '../features/manager/manager'
import { paymentApi } from '../features/payment/payment'
import { salesApi } from '../features/sales/sales'
import { sellersReportApi } from '../features/sales/sellersReportSlice'
import { promocodeApi } from '../features/promocode/promocode'
import { homeworkApiSlice } from '../features/section/homeworkSlice'
import { courseSalesApi, paymentKaspiOnlineApi } from '../features/sales/courseSalesSlice'
import { lessonScheduleApiSlice } from '../features/schedule/lessonScheduleSlice'
import { videonotesApiSlice } from '../features/section/videonotesSlice'
import { curatorProfileApiSlice } from '../features/curator/curatorProfileSlice'
import { examAnalysisApiSlice } from '../features/curator/examAnalysisSlice'
import { ratingApiSlice } from '../features/rating/ratingSlice'

export const store = configureStore({
    reducer: {
        user: userReducer,
        group: groupReducer,
        [userApiSlice.reducerPath]: userApiSlice.reducer,
        [subjectApiSlice.reducerPath]: subjectApiSlice.reducer,
        [courseApiSlice.reducerPath]: courseApiSlice.reducer,
        [topicApiSlice.reducerPath]: topicApiSlice.reducer,
        [courseSubjectApiSlice.reducerPath]: courseSubjectApiSlice.reducer,
        [courseTopicApiSlice.reducerPath]: courseTopicApiSlice.reducer,
        [testApiSlice.reducerPath]: testApiSlice.reducer,
        [videoLessonApiSlice.reducerPath]: videoLessonApiSlice.reducer,
        [studentApiSlice.reducerPath]: studentApiSlice.reducer,
        [teacherApiSlice.reducerPath]: teacherApiSlice.reducer,
        [groupApiSlice.reducerPath]: groupApiSlice.reducer,
        [groupSubjectApiSlice.reducerPath]: groupSubjectApiSlice.reducer,
        [courseUserApiSlice.reducerPath]: courseUserApiSlice.reducer,
        [curatorStudentsApiSlice.reducerPath]: curatorStudentsApiSlice.reducer,
        [sectionApiSlice.reducerPath]: sectionApiSlice.reducer,
        [coursePriceApi.reducerPath]: coursePriceApi.reducer,
        [courseSubjectPriceApi.reducerPath]: courseSubjectPriceApi.reducer,
        [coursePromotionApi.reducerPath]: coursePromotionApi.reducer,
        [coursePackageApi.reducerPath]: coursePackageApi.reducer,
        [courseExamApiSlice.reducerPath]: courseExamApiSlice.reducer,
        [managerApi.reducerPath]: managerApi.reducer,
        [paymentApi.reducerPath]: paymentApi.reducer,
        [salesApi.reducerPath]: salesApi.reducer,
        [sellersReportApi.reducerPath]: sellersReportApi.reducer,
        [promocodeApi.reducerPath]: promocodeApi.reducer,
        [homeworkApiSlice.reducerPath]: homeworkApiSlice.reducer,
        [courseSalesApi.reducerPath]: courseSalesApi.reducer,
        [paymentKaspiOnlineApi.reducerPath]: paymentKaspiOnlineApi.reducer,
        [lessonScheduleApiSlice.reducerPath]: lessonScheduleApiSlice.reducer,
        [videonotesApiSlice.reducerPath]: videonotesApiSlice.reducer,
        [curatorProfileApiSlice.reducerPath]: curatorProfileApiSlice.reducer,
        [examAnalysisApiSlice.reducerPath]: examAnalysisApiSlice.reducer,
        [ratingApiSlice.reducerPath]: ratingApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([
            subjectApiSlice.middleware,
            courseApiSlice.middleware,
            topicApiSlice.middleware,
            courseSubjectApiSlice.middleware,
            courseTopicApiSlice.middleware,
            testApiSlice.middleware,
            videoLessonApiSlice.middleware,
            studentApiSlice.middleware,
            teacherApiSlice.middleware,
            userApiSlice.middleware,
            groupApiSlice.middleware,
            groupSubjectApiSlice.middleware,
            courseUserApiSlice.middleware,
            curatorStudentsApiSlice.middleware,
            sectionApiSlice.middleware,
            coursePriceApi.middleware,
            courseSubjectPriceApi.middleware,
            coursePromotionApi.middleware,
            coursePackageApi.middleware,
            courseExamApiSlice.middleware,
            managerApi.middleware,
            paymentApi.middleware,
            salesApi.middleware,
            sellersReportApi.middleware,
            promocodeApi.middleware,
            courseSalesApi.middleware,
            paymentKaspiOnlineApi.middleware,
            lessonScheduleApiSlice.middleware,
            videonotesApiSlice.middleware,
            curatorProfileApiSlice.middleware,
            examAnalysisApiSlice.middleware,
            ratingApiSlice.middleware,
            rtkQueryErrorLogger,
        ]),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>
